export default "__VITE_ASSET__c95c3338__"